var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"four-zero-four"},[_c('div',{staticClass:"text-center",staticStyle:{"padding":"50px 0px"}},[_c('h4',[_vm._v("404. That an error.")]),_c('p',[_vm._v("The requested URL was notfound on this server.")])])])
}]

export { render, staticRenderFns }